import { isDefined } from './helpers';

export function initHeader() {
    menu();
    if (window.matchMedia("(min-width: 900px)").matches) {
        initVideo();
    }
}

function initVideo() {
    const wrapper = document.querySelector(".header-video-wrapper video") || null;
    if (!isDefined(wrapper)) return;
    const url = wrapper.dataset.src || null;
    if (!isDefined(url)) return;
    let source = document.createElement('source');
    source.setAttribute('src', url);
    source.setAttribute('type', 'video/webm');
    wrapper.appendChild(source);
}

function menu()
{
    const openButton = document.querySelector('#open-button');
    const closeButton = document.querySelector('#close-button');
    if(isDefined(openButton))
    {
        openButton.addEventListener('click', openMenu);
    }
    if(isDefined(closeButton))
    {
        closeButton.addEventListener('click', closeMenu);
    }
}

function openMenu()
{
    if(document.body.classList.contains('menu-is-open')) return;
    document.body.classList.add('menu-is-open');
}

function closeMenu()
{
    if(!document.body.classList.contains('menu-is-open')) return;
    document.body.classList.remove('menu-is-open');
}
